module.exports = __webpack_public_path__ + "static/img/s-apple-1.79ffecb.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/clac/img/s-apple-1.png
// module id = TWHl
// module chunks = 1